import { makeEventId } from "@/businessLogics/_common/logging/makeEventId";
import { track } from "../../../../../lib/facebook";
import { gtagReportConversion, marketingGtag } from "../../../../../lib/gtag";

export const addToCartEvent = (courseName: string) => {
  let eventId = makeEventId();
  track(
    "AddToCart",
    {
      content_category: "swcamp",
      content_type: "product",
      content_name: courseName,
    },
    eventId
  );
  marketingGtag("add_to_cart", {
    id: "swcamp",
  });
  gtagReportConversion("wCEuCKqGmYIYENiI190C");
};
